import { toast } from "react-toastify";
import { actualizarSector } from "../../domain/mapa/mapa";
import { quitarObjetos, seleccionDeObjetos } from "../../domain/mapa/seleccion";
import useEditorMapa from "../../stores/useEditorMapa";

// cambiarSector aplica una operación del generador (aplicarFilas,
// agregarMesa…) sobre un sector. Si la operación devuelve un error, el mapa no
// cambia y se avisa. Devuelve el resultado de la operación (para la clave de
// una mesa nueva, por ejemplo).
export const cambiarSector = (cambiar, claveSector, operacion, opciones) => {
  let resultado = null;
  let error = null;
  cambiar((mapa) => {
    const sector = mapa.sectores.find((s) => s.clave === claveSector);
    if (!sector) return mapa;
    resultado = operacion(sector);
    if (resultado?.error) {
      error = resultado.error;
      return mapa;
    }
    const nuevo = resultado?.sector !== undefined ? resultado.sector : resultado;
    return actualizarSector(mapa, claveSector, nuevo);
  }, opciones);
  if (error) toast.error(error, { toastId: error });
  return error ? null : resultado;
};

// borrarVarios borra lo elegido que se pueda; lo que tiene ventas o tarifas
// queda elegido y se avisa
export const borrarVarios = (elementos) => {
  const { cambiar, seleccionar } = useEditorMapa.getState();
  let omitidos = [];
  cambiar((mapa) => {
    const r = quitarObjetos(mapa, elementos);
    omitidos = r.omitidos;
    return r.mapa;
  });
  const quedan = elementos.filter((e) => useEditorMapa.getState().historial.presente.sectores.some((s) => s.clave === e.clave));
  seleccionar(seleccionDeObjetos(quedan));
  if (omitidos.length > 0) toast.warning(`No se borraron: ${omitidos.join(", ")}.`, { toastId: "borrar-varios" });
};
